import { cn } from '../utils/cn';

export interface SkeletonProps {
  theme?: 'light' | 'dark';
  className?: string;
}

/**
 * A placeholder component for loading content.
 * @see {@link https://stylus.design/skeleton}
 */
export const Skeleton = ({ className, theme, ...props }: SkeletonProps) => {
  return (
    <div
      className={cn(
        'animate-pulse bg-slate-200',
        { 'bg-slate-200': theme === 'light', 'bg-slate-700': theme === 'dark' },
        className,
      )}
      {...props}
    />
  );
};
